<template>
  <div class="col-md-6 offset-md-3 search-terms" v-show="!connection.destroy">
    <strong>{{ connection.nameForSelect }}</strong>
    <span v-if="connection.searchTerms.length" class="badge badge-default badge-pill">{{ searchTermsChecked.length }}</span>
    <input type="hidden" :name="`report_configuration[locations_report_configurations_attributes][][id]`" :value="connection.id" v-if="connection.id">
    <input type="hidden" :name="`report_configuration[locations_report_configurations_attributes][][remote_location_id]`" :value="connection.remoteId">

    <input
      v-if="connection.destroy"
      type="hidden"
      :name="`report_configuration[locations_report_configurations_attributes][][_destroy]`"
      :value="true">

    <template v-if="connection.searchTerms.length">
      <transition-expand>
        <div v-show="showList" class="mt-1">
          <div class="input-group input-group-sm mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fa fa-search" aria-hidden="true" /></span>
            </div>
            <input type="text" class="form-control" v-model="filter" autocomplete="new-password">
          </div>

          <ul class="pl-3 search-terms-list">
            <li v-for="(st, i) in searchTerms" v-show="showSearchTerm(st, i)">
              <input
                type="checkbox"
                v-model="st.checked"
                :checked="st.checked"
                :id="`st-${st.obfuscatedId}`"
                :value="st.obfuscatedId"
                :name="`report_configuration[locations_report_configurations_attributes][][search_term_ids][]`">

              <label :for="`st-${st.obfuscatedId}`">{{ st.text }}</label>
            </li>
          </ul>

          <paginate
            v-if="searchTermsPages > 1"
            v-model="page"
            :page-count="searchTermsPages"
            container-class="pagination mt-3"
            page-class="page-item"
            page-link-class="page-link"
            prev-class="page-item"
            prev-link-class="page-link"
            next-class="page-item"
            next-link-class="page-link"
            prev-text="<"
            next-text=">" />
        </div>
      </transition-expand>

      <div>
        <a href="#" @click.prevent="showList = !showList">
          <i :class="`fa fa-caret-${showList ? 'up' : 'down'}`" aria-hidden="true" /> {{ showList ? 'Hide' : 'Show' }} Search Terms
        </a>
      </div>
    </template>
    <p v-else class="mb-0">No Search terms for this location</p>
  </div>
</template>

<script>
import VuejsPaginate from 'vuejs-paginate'

export default {
  components: { paginate: VuejsPaginate },
  props: ['connection'],
  data() {
    return {
      show: true,
      showList: false,
      filter: '',
      page: 1,
      perPage: 10
    }
  },
  computed: {
    searchTerms() {
      return this.connection.searchTerms
    },
    searchTermsChecked() {
      return this.searchTerms.filter((el) => el.checked)
    },
    filteredSeatchTerms() {
      return (this.filter === '' ? this.searchTerms : this.searchTerms.filter((el) => el.text.includes(this.filter)))
    },
    searchTermsPages() {
      return Math.ceil(this.filteredSeatchTerms.length / this.perPage)
    },
    fromOffset() {
      return (this.page - 1) * this.perPage
    },
    toOffset() {
      return this.page * this.perPage
    }
  },
  watch: {
    filter() {
      this.page = 1
    }
  },
  methods: {
    showSearchTerm(st) {
      const i = this.filteredSeatchTerms.indexOf(st)
      const byFiler = this.filter !== '' ? st.text.includes(this.filter) : true
      const byPage = i >= this.fromOffset && i < this.toOffset

      return byFiler && byPage
    }
  }
}
</script>
